import React from "react";

interface ReferralItemProps {
  name: string;
  date: string;
  status: string;
  statusColor: string;
  EarningsLabel: string;
  earningsColor: string;
  statusImage: string;
  earningsImage: string;
}// xl:gap-32 lg:gap-32

const ReferralItem: React.FC<ReferralItemProps> = ({
  name,
  date,
  status,
  statusColor,
  EarningsLabel,
  earningsColor,
  statusImage,
  earningsImage,
}) => {
  return (
    <div className="mt-4 flex flex-col gap-6 lg:flex-row xl:flex-row items-center justify-between">
      <div className="flex items-center">
        <img
          src="../../images/Avatarimage.jfif"
          alt="User Profile"
          className="rounded-full w-10 h-10 mr-4"
        />
        <div className="flex flex-col">
        <div className="text-lg font-semibold">{name}</div>
        <div className="text-sm text-gray-400">{date}</div>
        </div>
        
      </div>

      <div
        className={`px-4 py-2 rounded-md ${statusColor} border border-current flex items-center justify-center gap-3`}
      >
        <img src={statusImage} alt="status-logo" className="w-6 h-6" />
        {status}
      </div>

      <div
        className={`px-4 py-2 rounded-md ${earningsColor} border border-current flex items-center justify-center gap-3`}
      >
        <img src={earningsImage} alt="earnings-logo" className="w-6 h-6" />
        {EarningsLabel}
      </div>
    </div>
  );
};

export default ReferralItem;
